"use client";

import { Scale } from "@/animations/scale";
import Image from "@/components/Image";
import { cn } from "@/utils";
import { useResize } from "@/utils/useResize";
import { cva } from "class-variance-authority";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { HeaderFinder } from "./header-finder";
import { WrapperFinder } from "./wrapper-finder";

const variants = cva("w-full", {
  variants: {
    twSize: {
      xs: "max-w-[80%] ml-[14px] mt-[32px]",
      sm: "max-w-[80%] ml-[14px] mt-[32px]",
      md: "max-w-[529px] ml-[14px] mt-[32px]",
      lg: "max-w-[529px] ml-[32px] mt-[32px]",
      xl: "max-w-[470px] ml-[106px] -mt-[194px]",
      "2xl": "max-w-[499px] ml-[113px] -mt-[206px]",
      "3xl": "max-w-[529px] ml-[120px] -mt-[291px]",
    },
  },
  defaultVariants: {
    twSize: "2xl",
  },
});

export function FinderBeraStater() {
  const { twSize } = useResize();

  return (
    <Scale>
      <WrapperFinder
        className={cn(variants({ twSize: twSize }), "overflow-hidden")}
      >
        <HeaderFinder>
          <p className="text-[#23262F] text-center text-[13px] font-medium leading-4 truncate">
            Bera Starter
          </p>
        </HeaderFinder>

        <div
          className={"flex flex-col rounded-b-2xl overflow-hidden"}
          style={{
            background:
              "linear-gradient(161deg, #663214 27.48%, #4B1E00 97.22%)",
          }}
        >
          <div className="p-5">
            <p className="text-xl md:text-[1.75rem] md:leading-[2.5rem] font-medium">
              <span className="text-white">
                A fast, secured, and efficient platform
              </span>{" "}
              <span className="text-[#A3A8B5]">
                for decentralized fundraising on Berachain
              </span>
            </p>
          </div>
          <div>
            <Image
              src={require("@/assets/bg/bg_berastarter.png")}
              alt="Bera starter"
              width={529}
              height={306}
              className="w-full"
            />
          </div>

          <div
            className={clsx(
              "grid grid-cols-[40px_1fr_126px] md:grid-cols-[48px_1fr_142px] gap-2.5 lg:gap-4 p-4",
              "p-4 border-t border-white/15 bg-black/10"
            )}
          >
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl flex-shrink-0">
              <Image
                src={require("@/assets/icons/ic_bera_stater.png")}
                className="w-full h-full object-cover"
                alt="close"
                width={144}
                height={144}
              />
            </div>

            <div className="flex-1 flex flex-col items-start justify-center">
              <p className="text-sm font-medium text-white line-clamp-1">
                Bera Starter
              </p>
              <p className="text-sm font-medium text-white/60 line-clamp-1">
                Bera Starter Launchpad
              </p>
            </div>
            <div className="flex items-center justify-end">
              <Link
                className={clsx(
                  "px-6 py-2.5 rounded-full bg-white relative z-10 text-sm text-[#141416] font-medium whitespace-nowrap"
                )}
                to={"https://berastarter.holdstation.com"}
                target="_blank"
                data-action="redirect_berastarter"
              >
                Explore
              </Link>
            </div>
          </div>
        </div>
      </WrapperFinder>
    </Scale>
  );
}
